import styles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import React from 'react';
import Button from '../common/ui-components/input/Button';
import { ContactUs } from './ContactUsModal';
import { useState } from 'react';


interface MainProps{
    subIssues: any
}
const LockDown = (props:MainProps) => {

    const [writeToUs, setWriteToUs] = useState(false);

    return (
        <div className={styles.input_parent}>

          <h6>Greetings from Onsitego!</h6>
          <p className={styles.lockdown_para}>Due to restrictions imposed by Government on public movement, our Service Centers are unable to send technicians to your place during this period. Hence there may be a delay in services and technician visit will be arranged once restrictions are lifted. We expect a backlog of service requests and our efforts will be to serve you in earliest possible manner.</p>
          <p className={styles.lockdown_para}>We will keep you informed in case of any change depending on Local Authority Advisory. During this period, our normal Service timelines would not be applicable.</p>
          <p className={styles.lockdown_para}>Regret the inconvenience caused and appreciate your support and understanding.</p>
          <p className={styles.lockdown_para}>In case of any query please reach us out on 9920599206.</p>
          <p className={styles.lockdown_para}>Stay safe!</p>
          <p className={styles.lockdown_para}>Onsitego Team</p>

          <Button  
                disabled={false} 
                className={styles.cart_btn} 
                text={'Contact Us'} 
                variant='secondary'
                onClick={() => {setWriteToUs(true)}}
                style={{'marginTop': '30px'}}
            />

            <ContactUs is_open={writeToUs} closeModal={setWriteToUs} subIssues={props.subIssues} />
            
        </div>
    )
}

export default LockDown;
